/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

export const UPDATE_FLOW_START_SUCCESS = 'UPDATE_FLOW_START_SUCCESS'
export const UPDATE_FLOW_START_FAILURE = 'UPDATE_FLOW_START_FAILURE'
// ____________________________________________________________

/**
 * Update the values of a flowStart broadcast two types of events:
 * - UPDATE_FLOW_START_SUCCESS: in case of success
 * - UPDATE_FLOW_START_FAILURE: in case of failure.
 *
 * @param {number} pid Project Id UUID
 * @param {number} sid Scenario Id UUID
 * @param {number} fid FlowGroup Id UUID
 * @param {object} flowStart Flow to update. MUST contains and `id` attribute
 * @returns {Promise<object>}
 */
export const updateFlowStart = (pid, sid, fid, flowStart) => async (dispatch) => {
  if (!flowStart) {
    return
  }

  const path = getApiPath(apiPaths.FLOW_START_UPDATE, { pid, sid, fid, oid: flowStart.id })
  const api = new Api(path)
  const result = await api.update(flowStart)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowStartsActions.updateFlowStart()', { path, result, flowStart })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_FLOW_START_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_FLOW_START_FAILURE,
    data: result.data
  })
}
